import { Navigate, Outlet } from 'react-router-dom'
import AppLayout from './AppLayout';
const PrivateRoutes = ({ permissions = [] }) => {
    const token = window.localStorage.getItem('token');
    const donor = window.localStorage.getItem('donor')?.toString();
    return (
        token && donor != "true" ? <AppLayout><Outlet /></AppLayout> : <Navigate to='/login' />
    )
}
export default PrivateRoutes;